import React from 'react';

import { StyledBackground } from './Background.styled';

const Background: React.FC = () => {
	return <StyledBackground />;
};

export { Background };
